import { render, staticRenderFns } from "./SubclientAddPage.vue?vue&type=template&id=da16a850&scoped=true"
import script from "./SubclientAddPage.vue?vue&type=script&lang=ts"
export * from "./SubclientAddPage.vue?vue&type=script&lang=ts"
import style0 from "./SubclientAddPage.vue?vue&type=style&index=0&id=da16a850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da16a850",
  null
  
)

export default component.exports